import * as React from "react";
import "./Content.css";
import Routes from "../Routes";

const Content: React.FC = () => {
    return <Routes></Routes>;
};

export default Content;